var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var InterventionNavListItem = createReactClass({
    mixins: [PureRenderMixin],

    handleSponsoredPlacementChange: function(ev){
        ev.stopPropagation();

        this.props.onSponsoredPlacementChange(this.props.intervention);

        // tracking
    },

    handleClickTracking: function(ev){
        ev.stopPropagation();
        var target = ev.target;
        var label = target.getAttribute('href');
        var action = target.innerText;
        this.props.clickTracking(action, label);
    },

	render: function(){
        var intervention = this.props.intervention;
        var hasSponsoredPlacement = intervention.isSponsored && intervention.sponsoredPlacement.webTag;

		return (
            <li className={'intervention-nav-list-item' + (intervention.isSponsored ? ' isSponsored' : '')} onTouchStart={function(){}} onClick={hasSponsoredPlacement && this.handleSponsoredPlacementChange}>
                <div className="intervention-nav-list-item-inner">
                    <p>
                        {intervention.commercialName !== '' &&
                            <span className="intervention-commercial-name">{intervention.commercialName}</span>
                        }
                        {intervention.genericName &&
                            <span className="intervention-generic-name">{intervention.genericName}</span>
                        }
                    </p>
                    {hasSponsoredPlacement &&
                        <a className="special-button button tiny">Learn More</a>
                    }
                    {!intervention.isSponsored &&
                        <div className="intervention-pop-info">
                            <div className="intervention-pop-info-inner">
                                <p>{intervention.popup}</p>
                                {intervention.url && (
                                    <p><a href={intervention.url} target="_blank" rel="noopener noreferrer" onClick={this.handleClickTracking}>{intervention.url}</a></p>
                                )}
                            </div>
                        </div>
                    }
                </div>
            </li>
	    )
	}
});

module.exports = InterventionNavListItem;



// WEBPACK FOOTER //
// ./src/common/routes/conditions/components/layout/interventionNavListItem.jsx